import { gql } from '@apollo/client'
import { BodyText, Card, Chip, Heading } from '@farol-ds/react'
import { ButtonKindEnum } from '@jusbrasil-web/shared-apollo-client/types'
import classNames from 'classnames'

import { BenefitsList } from '../../../benefits-list'
import { CheckoutButton } from '../../../checkout-button'
import { OneClickButton } from '../../../one-click-button'
import {
  OfferCard_OfferCardDataFragment,
  OfferCard_ViewerFragment,
} from './__generated__/offer-card.graphql'
import styles from './offer-card.module.scss'
import { OfferCardPrice } from './offer-card-price'

interface OfferCardProps {
  offerCardData: OfferCard_OfferCardDataFragment
  viewer: OfferCard_ViewerFragment
}

export const OfferCard = ({ offerCardData, viewer }: OfferCardProps) => {
  const { title, subtitle, offer, creditCard, benefitsList } = offerCardData
  const { isJusAIOffer } = offer

  const hasCreditCard = !!creditCard?.ccToken
  const kindSubmitButton = isJusAIOffer ? ButtonKindEnum.Primary : ButtonKindEnum.Secondary

  return (
    <div className={styles.container}>
      {isJusAIOffer && (
        <Chip size="sm" kind="secondary" className={styles.recommendedChip}>
          Recomendado
        </Chip>
      )}

      <Card
        highlight={!!isJusAIOffer}
        className={classNames(styles.cardContainer, { [styles.jusAIOfferCard]: isJusAIOffer })}
      >
        <div className={styles.cardHeader}>
          <Heading size="md" className={classNames({ [styles.jusAICardTitle]: isJusAIOffer })}>
            {title}
          </Heading>
          <BodyText size="md">{subtitle}</BodyText>
        </div>

        <OfferCardPrice className={styles.cardPrice} offerLockOffer={offer} />

        <div className={styles.paymentButtons}>
          <CheckoutButton kind={kindSubmitButton} offerLockCard={offerCardData} />
          {!!viewer && hasCreditCard && (
            <OneClickButton offerLockCard={offerCardData} viewer={viewer} kind={kindSubmitButton} />
          )}
        </div>

        <div>
          <BenefitsList
            offerLockCard={offerCardData}
            highlightFirstBenefit={!benefitsList[0]?.iconType}
          />
        </div>
      </Card>
    </div>
  )
}

OfferCard.fragments = {
  offerCardData: gql`
    fragment OfferCard_offerCardData on OfferLockCard {
      title
      subtitle
      offer {
        isJusAIOffer
        ...OfferCardPrice_offerLockOffer
      }
      buttons {
        label
        kind
      }
      benefitsList {
        iconType
        name
      }
      ...CheckoutButton_offerLockCard
      ...OneClickButton_offerLockCard
    }
    ${CheckoutButton.fragments.offerLockCard}
    ${OneClickButton.fragments.offerLockCard}
    ${OfferCardPrice.fragments.offerLockOffer}
  `,
  viewer: gql`
    fragment OfferCard_viewer on Profile {
      pid
      ...OneClickButton_viewer
    }
    ${OneClickButton.fragments.viewer}
  `,
}
